import type {
  RelationshipEntityReferenceAnnotation,
  IdEntityReferenceAnnotation,
} from '@web-config-app/core';

export const isRelationshipEntityReference = (
  entityReference:
    | RelationshipEntityReferenceAnnotation
    | IdEntityReferenceAnnotation
    | undefined,
): entityReference is RelationshipEntityReferenceAnnotation =>
  Boolean(entityReference && 'relationship' in entityReference);
